import { TwainGameId } from 'betgames-contract-js';

export const NEW_GAMES: TwainGameId[] = [];

export const ROOT_CLASS = 'root';

export const AUTH_HEADER_NAME = 'Authorization';

export const LOCALE_HEADER_NAME = 'locale';

export const PARTNER_CODE_HEADER_NAME = 'partner-code';

export const TIMEZONE_HEADER_NAME = 'timezone';

export const DEFAULT_LOCALE = 'en';

export const TIME_FORMAT = 'HH:mm';

export const SEASON_DATE = 'yyyy-MM';

export const DATE_FORMAT = 'yyyy-MM-dd';

export const MAX_DESKTOP_VIEW_WIDTH = 768;

export const MAX_BETS = 15;

export const MIN_MULTI_BET_OPTIONS = 2;

export const EXPIRED_BET_REMOVAL_TIMEOUT = 5000;

export const SHOW_SUCCESS_MESSAGE = 3000;

export const MIN_BET_RESPONSE_MESSAGE = 2000;

export const GAME_MESSAGE_DURATION = 5000;

export const WIN_MESSAGE_DURATION = 2500;

export const MAX_BETS_MESSAGE_DURATION = 5000;

export const INFO_GAME_MESSAGE_DURATION = 10000;

export const MESSAGE_ANIMATION_DURATION = 300;

export const FULLSCREEN_SETTING_TIMEOUT = 3 * 1000; // 3s

export const STORED_DATA_LIMIT_MONTHS = 3;

export const UUID_VISIBLE_LENGTH = 10;

export const HOLD_SUCCESS_COPY_MESSAGE = 2000;

export const INPUT_AMOUNT_MAX_LENGTH = 9;

export const MAX_VISIBLE_BET_OPTIONS = 10;

// RNG constants

export const RNG_LAST_RESULTS_AMOUNT = 5;

export const RNG_T_KICK_TOTAL_MARKET_BASE_SCORE = 9.5;

export const RNG_T_BASKET_TOTAL_MARKET_BASE_SCORE = 20.5;

export const RNG_RIGHT_PLAYER_CODE = 'VIRTUALPARTICIPANT00000001';

export const RNG_LEFT_PLAYER_CODE = 'VIRTUALPARTICIPANT00000002';

export const RNG_STREAM_DELAY = 8000; // 8s

export const RNG_PRE_MATCH_DELAY = 12000; // 12s

export const RNG_BASE_MATCH_DURATION = 60; // 60s

export const RNG_GUI_MATCH_DURATION = RNG_BASE_MATCH_DURATION + RNG_PRE_MATCH_DELAY / 1000; // 72s

export const RNG_MATCH_DURATION = 80; // 80s = 72s + 8s delay

export const PIXEL_ROUNDING_OFFSET = 1;
